import { alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";

import { SET_ICONS } from "../types/iconsTypes";
import axios from "axios";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const setAllIcons = (icons) => ({ type: SET_ICONS, payload: icons });

export const fetchAllIcons = () => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.get(`/model/quiz_images`);
      const icons = res.data;
      dispatch(setAllIcons(icons));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
